import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SwitchListItem from '../../../../../../list-items/SwitchListItem/SwitchListItem';

const WaveLayerInvertListItem = memo(({ index, inverted, updateWaveLayerCustomOptions }) => {
    const handleChange = useCallback(
        (_,value) => updateWaveLayerCustomOptions(index, "inverted", value),
        [index]
    );

    return (
        <SwitchListItem
            checked={inverted}
            onChange={handleChange}
            text="Invert Spectrum"
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { inverted } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    return { inverted };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerInvertListItem);
